import { FIRELINE_MEDIC_BADGE } from './firelineMedicBadge';
import { SMFD_LINE_MEDIC_BADGE } from './smfdLineMedicBadge';

export const GENERIC_LINE_MEDIC_BRAND = Object.freeze({
  tenantId: 'generic',
  tenantName: '',
  shortTenantName: '',
  productName: 'Line Medic',
  displayName: 'Line Medic',
  kicker: 'LINE MEDIC · WILDLAND MEDICAL',
  logo: FIRELINE_MEDIC_BADGE,
  coBranded: false,
});

export const METRO_FIRE_LINE_MEDIC_BRAND = Object.freeze({
  tenantId: 'sac-metro-fire',
  tenantName: 'Sacramento Metropolitan Fire District',
  shortTenantName: 'Metro Fire',
  productName: 'Line Medic',
  displayName: 'Metro Fire · Line Medic',
  kicker: 'METRO FIRE · LINE MEDIC',
  logo: SMFD_LINE_MEDIC_BADGE,
  coBranded: true,
});

export const DEMO_FIRE_AGENCY_BRAND = Object.freeze({
  tenantId: 'demo-fire-agency',
  tenantName: 'Demo Fire Agency',
  shortTenantName: 'Demo Fire Agency',
  productName: 'Line Medic',
  displayName: 'Demo Fire Agency · Line Medic',
  kicker: 'DEMO FIRE AGENCY · LINE MEDIC',
  logo: FIRELINE_MEDIC_BADGE,
  coBranded: true,
});


export function authenticatedTenantBrand(profile) {
  const email = String(profile?.email || '').trim().toLowerCase();
  if (String(profile?.tenant_id || '').trim().toLowerCase() === 'demo-fire-agency') {
    return DEMO_FIRE_AGENCY_BRAND;
  }
  // 1.2 currently has one authenticated production tenant. REMS uses the same
  // operational tenant brand after authentication, but keeps its restricted
  // member feature surface.
  if (email.endsWith('@metrofire.ca.gov')) {
    return METRO_FIRE_LINE_MEDIC_BRAND;
  }
  return GENERIC_LINE_MEDIC_BRAND;
}
